import { Label } from "@/components/ui/label";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import type { Department, SeniorityLevel } from "@/types";
import { JoinDateInput } from "./join-date-input";
import { DEPARTMENT_OPTIONS, SENIORITY_LEVEL_OPTIONS } from "./staff-profile-options";

interface StaffProfileFieldsProps {
    seniorityLevel?: SeniorityLevel;
    department?: Department;
    joinDate?: Date;
    onSeniorityLevelChange: (value: SeniorityLevel) => void;
    onDepartmentChange: (value: Department) => void;
    onJoinDateChange: (value: Date | undefined) => void;
}

/** HR profile fields (SHP-2896) — seniority_level/department are fixed enums, join_date is a calendar date. */
export function StaffProfileFields({
    seniorityLevel,
    department,
    joinDate,
    onSeniorityLevelChange,
    onDepartmentChange,
    onJoinDateChange,
}: StaffProfileFieldsProps) {
    return (
        <>
            <div className="space-y-2">
                <Label htmlFor="seniorityLevel">Seniority Level</Label>
                <Select value={seniorityLevel} onValueChange={(value) => onSeniorityLevelChange(value as SeniorityLevel)}>
                    <SelectTrigger id="seniorityLevel">
                        <SelectValue placeholder="Select seniority level" />
                    </SelectTrigger>
                    <SelectContent>
                        {SENIORITY_LEVEL_OPTIONS.map((option) => (
                            <SelectItem key={option.value} value={option.value}>
                                {option.label}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>
            <div className="space-y-2">
                <Label htmlFor="department">Department</Label>
                <Select value={department} onValueChange={(value) => onDepartmentChange(value as Department)}>
                    <SelectTrigger id="department">
                        <SelectValue placeholder="Select department" />
                    </SelectTrigger>
                    <SelectContent>
                        {DEPARTMENT_OPTIONS.map((option) => (
                            <SelectItem key={option.value} value={option.value}>
                                {option.label}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>
            <div className="space-y-2">
                <Label htmlFor="joinDate">Join Date</Label>
                <JoinDateInput id="joinDate" value={joinDate} onChange={onJoinDateChange} />
            </div>
        </>
    );
}
